module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/mainvisual-date-sp-buyback_a1b085c0a2933ba139121c067c39015a.png";